module.exports = __webpack_public_path__ + "static/tat-31-bb4b65d7a5d80ad89b5ef6e056edf910.jpg";